import styled from "styled-components";

import { COLORS } from "~/src/styles/config.style";

export const PaginationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const TotalFound = styled.span`
  color: ${COLORS.DARK_GREY};
  font-size: 13px;
  font-weight: 600;
  margin-left: 8px;
`;

export const PageButton = styled.button<{ isActive?: boolean }>`
  border: 1px solid
    ${({ isActive }) => (isActive ? COLORS.MAIN_ORANGE : COLORS.CLOUDY_BLUE)};
  background: ${({ isActive }) =>
    isActive ? COLORS.MAIN_ORANGE : COLORS.WHITE};
  color: ${({ isActive }) => (isActive ? COLORS.WHITE : COLORS.DARK_GREY)};
  border-radius: 8px;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Ellipsis = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  color: ${COLORS.GREY_DARK};
  font-weight: 700;
`;
